/* import __COLOCATED_TEMPLATE__ from './close-conversation.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();